import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { SharedFilterResultTypes } from '../../types';
import { PaginationResponseTypes } from '../../types/response';
import {
  deleteSharedFilterResult,
  getSharedFilterResult,
  retrySharedFilterResult,
} from '../../services/inventory-product.service';

export const storeName = 'sharedFilterResultEntity';

export const sharedFilterResultEntity = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: { ...baseEntity },
  effects: (dispatch: RematchDispatch<typeof sharedFilterResultEntity>) => ({
    async fetchSharedFilterResult(payload) {
      const resp: PaginationResponseTypes<SharedFilterResultTypes[]> = await getSharedFilterResult(
        payload
      );
      if (!resp) return null;
      const { data } = resp;
      this.saves(data.content);
      return resp;
    },

    async deleteSharedFilterResult(payload) {
      const result = await deleteSharedFilterResult(payload);
      return result;
    },

    async retrySharedFilterResult(payload) {
      const result = await retrySharedFilterResult(payload);
      return result;
    },
  }),
});

export default sharedFilterResultEntity;
